
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Form, Button as BButton, Button as BsButton } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { FormControlLabel, Radio } from "@mui/material";

function ContactModalPhone({ SaveForm, open, setSubFormData, hanldeModal, phoneDataList, dataType, setDataType,setLoading }) {


    const handleClose = () => {
        hanldeModal(false)
        setDataType('')
        setLoading(false)
    }

    const updateFieldChanged = index => e => {
        let newArr = [...phoneDataList]

        newArr.map((data, i) => {
            if (index === i) {
                // data.phone_number = data.phone_number ?? null;
                // data.ext = data.ext ?? null;
                data.account_main_contact_phone_main = 1;
            } else {

                // data.phone_number = data.phone_number ?? null;
                // data.ext = data.ext ?? null;
                data.account_main_contact_phone_main = 0;
            }
        });
        setSubFormData(newArr);
    }


    // React.useEffect(() => {
    //   if(phoneDataList.length) {
    //     phoneDataList.map((data) => {
    //       data.account_main_contact_phone_main = data.account_main_contact_phone_main == 1 ? true : false
    //     })
    //   }
    //   setphoneDataList(phoneDataList);
    // }, [phoneDataList])

    const handleSubmit = () => {
        // create-new-account-form

        let check = phoneDataList.find((a) => a.account_main_contact_phone_main ? true : false);
        if (check) {
            handleClose();
            SaveForm();
            // document.getElementById("create-new-account-form").submit();
        }
    }
    return (
        <>

            <Modal show={open} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Set Main Phone Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <ul>
                            {phoneDataList.filter(it=>it.account_main_contact_phone!="")?.length === 0 ? <li>
                                No Phone Numbers Found Please Add Some Numbers
                            </li>:""}
                            {phoneDataList.filter(it=>it.account_main_contact_phone!="").map((single, index) => (
                                <li key={index} >
                                    {/* <label htmlFor={'phone_'+single.phone_number} >
                        <input type="radio" />
                        <span>{single.phone_number}</span>
                    </label> */}
                                    {/* {JSON.stringify(single.account_main_contact_phone_main)} */}

                                    <Form.Group className={'col d-block'}>
                                        <b className={''}>Main</b>
                                        <div className="">
                                            <FormControlLabel
                                                className={''}
                                                label={`${single.account_main_contact_phone_ext} - ${single.account_main_contact_phone}`}
                                                value={true}
                                                name="main"
                                                onChange={updateFieldChanged(index)}
                                                control={<Radio checked={single.account_main_contact_phone_main} color="primary" size="medium" />}
                                            />


                                        </div>
                                    </Form.Group>

                                </li>
                            ))}
                        </ul>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    {/* <Button variant="link secondary" onClick={handleClose}>
            Close
          </Button> */}
                    <Button variant="primary" onClick={handleSubmit}>
                        Continue
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* <Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
>
  <Box sx={{ ...style, width: 400 }}>
    {dataType==='Phone' ? <>
        <div className='' >
    {JSON.stringify(phoneDataList)}
        </div>
    </> : <>
    {JSON.stringify(emailDataList)}
    
    </>}
  </Box>
</Modal> */}


        </>
    )
}

export default ContactModalPhone